import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  JobTypeServiceCreateResponseJson,
  JobTypeServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedJobTypeActions = createActionGroup({
  source: 'PaginatedJobType',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedJobTypes': props<{
      params: JobTypeServiceListRequestJson;
    }>(),
    'List PaginatedJobTypes Success': props<{
      data: ApiPaginated<JobTypeServiceCreateResponseJson>;
    }>(),
    'List PaginatedJobTypes Failure': props<{ error: unknown }>(),
  },
});
